import React from "react";
import { useTranslation } from "react-i18next";

const Loader = () => {
  const { t } = useTranslation();
  return (
    <div
      className="v-overlay v-overlay--active theme--dark"
      style={{ "z-index": "300" }}
    >
      <div
        className="v-overlay__scrim"
        style={{
          opacity: "0.8",
          "background-color": "rgb(33, 33, 33)",
          "border-color": "rgb(33, 33, 33)",
        }}
      />
      <div className="v-overlay__content">
        <div className="pulse">
          <img
            src="../../assets/images/logo.png"
            width={120}
            alt={t("Altwinx9CrazytimeExchange")}
          />
        </div>
      </div>
    </div>
  );
};

export default Loader;
